import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import form from '@/mixins/crud-form';
import utils from '@/utils/index';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'USER_DETAIL',
        create: 'USER_CREATE',
        update: 'USER_UPDATE'
      },
      dialog: {
        width: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'avatar',
        default: '',
        label: '头像',
        col: {
          span: 24
        },
        render: function render() {
          return h("d2-avatar-uploader", {
            "model": {
              value: _this.form.model.avatar,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "avatar", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_name',
        default: '',
        label: '用户名',
        rule: [{
          required: true,
          message: '必填',
          trigger: 'change'
        }, {
          validator: utils.helper.isLegalUsernameValidator,
          trigger: 'change'
        }],
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'nickname',
        default: '',
        label: '昵称',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.nickname,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "nickname", $$v);
              }
            }
          });
        }
      }, {
        prop: 'sex',
        default: this.$env.VUE_APP_DICT_EMPTY_NUMBER,
        label: '性别',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "sex",
              "all": true,
              "all-label": "未知",
              "button": true
            },
            "model": {
              value: _this.form.model.sex,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "sex", $$v);
              }
            }
          });
        }
      }].concat(_toConsumableArray(this.mode === 'create' ? [{
        prop: 'password',
        default: '',
        label: '密码',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "type": "password",
              "clearable": true
            },
            "model": {
              value: _this.form.model.password,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "password", $$v);
              }
            }
          });
        }
      }] : []), [{
        prop: 'phone',
        default: '',
        label: '手机号码',
        rule: [{
          required: true,
          message: '必填',
          trigger: 'change'
        }],
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.phone,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "phone", $$v);
              }
            }
          });
        }
      }, {
        prop: 'email',
        default: '',
        label: '邮箱',
        rule: {
          validator: utils.helper.isLegalEmailValidator,
          trigger: 'change'
        },
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.email,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "email", $$v);
              }
            }
          });
        }
      }, {
        prop: 'dept_id',
        default: '',
        label: '归属部门',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-tree-popover", {
            "attrs": {
              "source": "DEPT_ALL",
              "key-label": "dept_name"
            },
            "model": {
              value: _this.form.model.dept_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dept_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_post',
        default: '',
        label: '岗位',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "user_post",
              "custom": true,
              "multiple": true,
              "stringify": true
            },
            "style": "width: 100%;",
            "model": {
              value: _this.form.model.user_post,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_post", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_role',
        default: '',
        label: '角色',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "user_role",
              "custom": true,
              "multiple": true,
              "stringify": true
            },
            "style": "width: 100%;",
            "model": {
              value: _this.form.model.user_role,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_role", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        default: this.$env.VUE_APP_DICT_STATUS_ACTIVE,
        label: '状态',
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'remark',
        default: '',
        label: '备注',
        col: {
          span: 24
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      }]);
    }
  },
  methods: {
    /**
     * @description 加载需要的字典数据
     */
    loadDict: function loadDict() {
      // 岗位
      this.loadDictOne({
        name: 'user_post',
        method: this.$api.POST_ALL,
        fields: 'id,post_name',
        path: 'list',
        label: 'post_name'
      }); // 角色

      this.loadDictOne({
        name: 'user_role',
        method: this.$api.ROLE_ALL,
        fields: 'id,role_name',
        path: 'list',
        label: 'role_name'
      });
    },

    /**
     * @description 在提交表单之前可选进行数据处理
     * @param {Object} data 默认的表单数据
     */
    transformSubmitData: function transformSubmitData(data) {
      if (this.mode === 'edit') {
        // 编辑模式下删除密码字段
        return this._.omit(data, ['password']);
      } else {
        // 新建模式下全部发送
        return data;
      }
    }
  }
};